import React from 'react';
import { X } from 'lucide-react';
export function WhyFailedSection() {
  const reasons = [{
    title: 'Te enfocaste en comer menos',
    desc: 'Resultado: más hambre, ansiedad y el inevitable rebote.'
  }, {
    title: "Cardio 'a lo loco' sin fuerza",
    desc: 'Resultado: más cansancio y poco cambio visible en la composición corporal.'
  }, {
    title: 'Consejos sueltos sin sistema',
    desc: 'Resultado: confusión y falta de seguimiento real.'
  }, {
    title: 'Perfecta 4 días, caos 3',
    desc: 'Resultado: el promedio semanal no ayuda a desinflamar.'
  }, {
    title: 'Subestimaste sueño y estrés',
    desc: 'Resultado: pagaste con antojos incontrolables.'
  }];
  return <section className="py-20 bg-[#3D4852] text-white" data-id="element-224">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-225">
        <h2 className="text-3xl lg:text-4xl font-serif font-bold text-center mb-16" data-id="element-226">
          Por qué lo que intentaste no funcionó
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-227">
          {reasons.map((reason, index) => <div key={index} className="bg-white/5 p-8 rounded-2xl backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-colors" data-id="element-228">
              <div className="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center mb-4" data-id="element-229">
                <X className="w-5 h-5 text-red-400" data-id="element-230" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#F5F0E8]" data-id="element-231">
                {reason.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-232">{reason.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}